import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  dialogContent: {
    width: "100%",
    fontFamily: "Manrope !important",
    flex: 1,
    flexDirection: "column",
    paddingBottom: "15px",
    alignItems: "center",
    justifyContent: "center"
  }
}));

export default styles;
